module.exports = __webpack_public_path__ + "static/media/quotation-marks.a27261fb.png";